import React, {useState, useEffect, Fragment} from "react";
import PropTypes from "prop-types";
import {UncontrolledTooltip} from "reactstrap";

/** This component will display reactstrap tooltip when content is overflowing from element */

const Tooltip = (props) => {
  const {
    target,
    placement = "auto",
    overflowType = "width",
    tooltip = document.getElementById(props.target)?.textContent,
  } = props;

  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = document.getElementById(target);
    if (element) {
      if (overflowType === "width") {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsOverflow(element.scrollWidth > element.offsetWidth);
      } else {
        setIsOverflow(element.scrollHeight > element.offsetHeight);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, document.getElementById(target), overflowType]);

  return (
    <Fragment>
      {isOverflow && (
        <UncontrolledTooltip target={target} placement={placement}>
          {tooltip}
        </UncontrolledTooltip>
      )}
    </Fragment>
  );
};

Tooltip.propTypes = {
  /** id of element on which tooltip needs to be displayed
   *  when content is overflowing from element */
  target: PropTypes.string.isRequired,
  /** Placement of tooltip on element */
  placement: PropTypes.oneOf([
    "auto",
    "auto-start",
    "auto-end",
    "top",
    "right",
    "bottom",
    "left",
    "top-start",
    "top-end",
    "bottom-start",
    "bottom-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end",
  ]),
  /** If set to width check for horizontal overflow
   *  If set to height check for vertical overflow
   */
  overflowType: PropTypes.oneOf(["width", "height"]),
  /** Text to be displayed in tooltip.
   * By default tooltip will show content of element
   */
  tooltip: PropTypes.string,
};

export default Tooltip;
